import React, { useState } from 'react';
import './index.css';
import QueueAnim from 'rc-queue-anim';
import clsx from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { getPageList } from '../config';
import { useAppContext } from 'context';

const Header = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const pageList = getPageList(pathname);
  const { dispatch } = useAppContext();

  const onClick = () => {
    setShow(!show);
  };

  const onLinkClick = () => {
    dispatch({
      type: 'SET_NEWS_CURRENT_PAGE',
      payload: 1,
    });
    // 切换到其它页面时，重置产品分类以及页码
    if (pathname !== '/productCenter') {
      dispatch({ type: 'SET_PRODUCT_TYPE', payload: '' });
      dispatch({
        type: 'SET_PRODUCT_CURRENT_PAGE',
        payload: 1,
      });
    }
  };

  const onPath = () => {
    dispatch({
      type: 'SET_NEWS_CURRENT_PAGE',
      payload: 1,
    });
    onClick();
  };

  return (
    <div className={clsx('header')}>
      <div className={clsx('navbar')}>
        <div className={clsx('container')}>
          <div className={clsx('navbar-header', { show: show })}>
            <Link to='/'>
              <img
                src='/img/logo.png'
                alt=''
                width={73}
                height={73}
                style={{ marginLeft: '15px' }}
              />
            </Link>
            <button
              type='button'
              className={clsx('navbar-toggle', { toggle: show })}
              onClick={onClick}
            >
              <span className={clsx('icon-bar', { iconTaggle: show })} />
              <span className={clsx('icon-bar', { iconTaggle: show })} />
              <span className={clsx('icon-bar', { iconTaggle: show })} />
            </button>
          </div>
          <div className={clsx('nav-ul')} key='one'>
            <ul className={clsx('ul')}>
              {pageList?.map((v, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={v.path}
                      className={clsx({ active: v.active })}
                      onClick={onLinkClick}
                    >
                      {v.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <QueueAnim
        className={clsx('content')}
        animConfig={[
          { opacity: [1, 0], translateY: [0, -30] },
          { opacity: [1, 0], translateY: [0, -30] },
        ]}
      >
        {show
          ? [
              <div className={clsx('select')} key='one'>
                <ul className={clsx('select-ul')}>
                  {pageList?.map((v, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={v.path}
                          onClick={onPath}
                          className={clsx({ active: v.active })}
                        >
                          {v.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>,
            ]
          : null}
      </QueueAnim>
    </div>
  );
};

export default Header;
